import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCustomStackoverflowAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		fill='currentColor'
		viewBox='0 0 24 24'
		width='1em'
		height='1em'
		className='svg-icon'
		{...props}>
		<path d='M15.09 22.41v-6.39h2.14v8.52H2.77v-8.52H4.9v6.39zm-8.27-2.13v-2.13h8.12v2.13zm.28-5.07.23-2.12 7.93.86-.24 2.12zm1.05-5.01.69-2.01 7.55 2.57-.68 2.01zm2.1-4.77 1.12-1.69 6.37 4.24-1.11 1.69zm4.16-3.96 5.05 6.79-1.7 1.27-5.05-6.79z' />
	</svg>
);
export default SvgCustomStackoverflowAlt;
